import { render, staticRenderFns } from "./resource_limit_settings.vue?vue&type=template&id=6cc5b7e6&scoped=true&"
import script from "./resource_limit_settings.vue?vue&type=script&lang=ts&"
export * from "./resource_limit_settings.vue?vue&type=script&lang=ts&"
import style0 from "./resource_limit_settings.vue?vue&type=style&index=0&id=6cc5b7e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc5b7e6",
  null
  
)

export default component.exports